// Prevents table row click handlers (e.g. Vuetify `@click:row`) from firing
// when the user finished a text selection (drag) inside a table row.
document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    const row = target instanceof Element ? target.closest('table tbody tr') : null;
    if (!row) return;
    const selection = window.getSelection();
    // Only ignore the click if the selection belongs to the clicked row,
    // so a stale selection elsewhere doesn't swallow clicks on buttons.
    if (
      selection &&
      !selection.isCollapsed &&
      selection.toString().trim() !== '' &&
      (row.contains(selection.anchorNode) || row.contains(selection.focusNode))
    ) {
      event.stopPropagation();
      // Also prevent the default action, e.g. a native link navigation inside the row
      event.preventDefault();
    }
  },
  true,
);
